import { create } from "zustand";

export type AppToastVariant = "success" | "error" | "info";

export type AppToastItem = {
  id: number;
  variant: AppToastVariant;
  message: string;
  /** 既定のアイコンの代わりに出す画像（例: 遠隔バイブの案内に Lovense のアイコン） */
  iconSrc?: string;
};

type AppToastState = {
  toast: AppToastItem | null;
  show: (variant: AppToastVariant, message: string, iconSrc?: string) => void;
  dismiss: () => void;
};

// トーストの再マウント判定に使う連番（key 用）
let toastIdCounter = 0;

export const useAppToastStore = create<AppToastState>((set) => ({
  toast: null,
  show: (variant, message, iconSrc) =>
    set({ toast: { id: ++toastIdCounter, variant, message, iconSrc } }),
  dismiss: () => set({ toast: null }),
}));
